




























































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';
import DiscountOffer from '@/components/molecules/DiscountOffer/DiscountOffer.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import { socialList } from '@/componentsV2/organisms/SocialRewards/CampaignList.vue';

import FacebookShareIcon from '@/components/icons/social-media/FacebookShare.vue';
import FacebookFollowIcon from '@/components/icons/social-media/FacebookFollow.vue';
import InstagramFollowIcon from '@/components/icons/social-media/InstagramFollow.vue';
import TwitterFollowIcon from '@/components/icons/social-media/TwitterFollow.vue';
import TwitterShareIcon from '@/components/icons/social-media/TwitterShare.vue';
import YouTubeSubscribeIcon from '@/components/icons/social-media/YouTubeSubscribe.vue';
import TikTokFollowIcon from '@/components/icons/social-media/TikTokFollow.vue';
import PinterestFollowIcon from '@/components/icons/social-media/PinterestFollow.vue';

@Component({
  components: {
    Typography,
    GhostButton,
    ArrowRightInfoIcon,
    DiscountOffer,
    FilterTag,
    ProgramStatusTag,
    FacebookShareIcon,
    FacebookFollowIcon,
    InstagramFollowIcon,
    TwitterFollowIcon,
    TwitterShareIcon,
    YouTubeSubscribeIcon,
    TikTokFollowIcon,
    PinterestFollowIcon
  }
})
export default class SocialRewardsItem extends Vue {
  @Prop() item!: any;

  get socialData() {
    return socialList.filter(item => item.type === this.item.type)[0] || {};
  }

  goToSocialReward() {
    this.$router.push(`/social-rewards/${this.item.type}/edit`);
  }
}
